<template>
    <div v-if="hasData">
        <public-profile-header></public-profile-header>
        <public-profile-body :profile-type="profileType"></public-profile-body>
        <public-profile-footer></public-profile-footer>
        <ncsa-guest-popup v-if="isGuest && showPopup"></ncsa-guest-popup>
    </div>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';

    import PublicProfileHeader from './components/PublicProfileHeader';
    import PublicProfileBody from './components/PublicProfileBody';
    import PublicProfileFooter from './components/VisualElements/PublicProfileFooter';
    import NcsaGuestPopup from '../Ncsa/NcsaGuestPopup';

    export default {
        props: {
            userId: {
                type: String,
                required: true
            },

            isGuest: {
                type: Boolean,
                default: true
            },

            profileType: {
                type: String,
                default: 'blast'
            },

            autoLogin: {
                type: Boolean,
                default: false
            }
        },

        name: 'PublicPlayerProfile',

        components: {
            PublicProfileHeader,
            PublicProfileBody,
            PublicProfileFooter,
            NcsaGuestPopup
        },

        data() {
            return {
                hasData: false
            }
        },

        computed: {
            showPopup() {
                return this.profileType == 'ncsa';
            }
        },

        methods: {
            ...mapActions({
                fetchPublicProfile: 'player-profile/fetchPublicProfile'
            }),

            ...mapMutations({
                setUserID: 'player-profile/setUserID'
            })
        },

        created() {
            this.setUserID(this.userId);

            this.fetchPublicProfile(this.userId).then(() => this.hasData = true);

            if (this.profileType == 'ncsa' && this.autoLogin) {
                trackEvent('ga-ncsa-auto-logged-in');
            }
        },
    }
</script>
